import { AddressSuggestion } from './address-suggestion';

export enum TexasServiceAddressSearchSource {
	Ercot = 'ercot',
	Supplier = 'supplier',
}

export interface TexasServiceAddressSuggestionData {
	utilityAccountNum: string;
	address1: string;
	address2?: string;
	city?: string;
	stateId?: string;
	zipCode?: string;
	utilityId?: string;
	zone?: string;
	source: TexasServiceAddressSearchSource;
	rank?: number;
}

export class TexasServiceAddressSuggestion {
	public utilityAccountNum: string;
	public address1: string;
	public address2: string;
	public city: string;
	public stateId: string;
	public zipCode: string;
	public utilityId?: string;
	public zone?: string;
	public source: TexasServiceAddressSearchSource;
	public rank: number;

	constructor(row: TexasServiceAddressSuggestionData) {
		Object.assign(this, {
			address2: '',
			city: '',
			stateId: '',
			zipCode: '',
			utilityId: '',
			zone: '',
			rank: 0,
			...row,
		});
	}

	get typeaheadLabel(): string {
		return AddressSuggestion.formatLabel(this.address1, this.address2, this.city, 'TX', this.zipCode);
	}
}
